import React, { useEffect, useState } from 'react';
import axios from '../Common/axios';
import { useParams } from 'react-router-dom';
import { Tabs, Button, Layout, Modal } from "antd";
import Report from './InfoReport';
import Measure from './InfoMeasure';
import Suggest from './InfoSuggest';
import Asset from './InfoAsset';
import Threat from './InfoThreat';
import Risk from './InfoRisk';
import Corrective from './InfoCorrective';
import { getFindReportIdInfo } from '../../pages/Common/api';
const { Content } = Layout;
const { TabPane } = Tabs;


function AnalysisInfo({ p_reportId, onClose }) {
    const params = useParams();
    //console.log(params.reportId);

    // 변수 선언
    const [reportInfo, setReportInfo] = useState({});
    const [companyCode, setCompanyCode] = useState('');
    const [assetType, setAssetType] = useState('');
    const [reportName, setReportName] = useState('');
    const [reportId, setReportId] = useState(p_reportId);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        //자동조회
        if (reportId) {
            findReportIdInfo();
        }
    }, [reportId]);

    // 레포트조회
    const findReportIdInfo = () => {
        axios.get(getFindReportIdInfo(reportId))
            .then((response) => {
                setReportInfo(response.data[0]);
                setCompanyCode(response.data[0].com_cd);
                setAssetType(response.data[0].asset_type);
                setReportName(response.data[0].report_nm);
                setReportId(response.data[0].report_id);
            })
            .catch((error) => {
                console.log("AnalysisInfot.js --- 46 error");
                console.dir(error);
            });
    }

    // 닫기
    const onClickCloseHandler = () => {
        //window.close();
        onClose?.(true);
    }

    const tabItems = [
        {
            label: '보고서상세',
            key: '1',
            children: <Report reportId={reportId} reportInfo={reportInfo} onChangeAfter={findReportIdInfo} onChangeClose={onClickCloseHandler} />,
        },
        {
            label: '진단항목',
            key: '2',
            children: <Measure reportId={reportId} reportInfo={reportInfo} />,
        },
        {
            label: '권고사항',
            key: '3',
            children: <Suggest reportId={reportId} reportInfo={reportInfo} />,
        },
        {
            label: '위협(Threat)',
            key: '4',
            children: <Threat reportId={reportId} reportInfo={reportInfo} />,
        },
        {
            label: '위험(Risk)',
            key: '5',
            children: <Risk reportId={reportId} reportInfo={reportInfo} />,
        },
        {
            label: '예외사항',
            key: '6',
            children: <Corrective reportId={reportId} reportInfo={reportInfo} assetType={assetType} />,
        },
        {
            label: '자산',
            key: '7',
            children: <Asset reportId={reportId} reportInfo={reportInfo} />,
        },
    ];

    // if(true){
    //     tabItems.splice(4,0,
    //         {
    //             label: '위험(Risk)',
    //             key: '4',
    //             children: <Risk reportId={reportId} reportInfo={reportInfo} />,
    //         }
    //     );
    // }

    return (
        <div className='layer_overlay'>
            <div className='layer_wrap' style={{ width: Math.ceil(window.innerWidth - 100), height: Math.ceil(window.innerHeight - 200) }}>
                <div className='popup_header'>
                    <div className='popup_title'>
                        취약점분석 : 기준
                    </div>
                </div>
                <div className="popup_button" style={{ top: '10px' }}>
                    <Button
                        type="default"
                        onClick={onClickCloseHandler}
                        style={{ marginLeft: '10px' }}
                    >
                        {'닫기'}
                    </Button>
                </div>
                <div className="section">
                    <table className='search'>
                        <colgroup>
                            <col style={{ width: '10%' }} />
                            <col style={{ width: '20%' }} />
                            <col style={{ width: '10%' }} />
                            <col style={{ width: '30%' }} />
                            <col style={{ width: '10%' }} />
                            <col style={{ width: '20%' }} />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>자산구분</th>
                                <td>{assetType}</td>
                                <th>취약점분석명</th>
                                <td>{reportName}</td>
                                <th>취약점분석ID</th>
                                <td>{reportId}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="section" style={{ borderTop: '0' }}>
                    <Content style={{ backgroundColor: '#f5f5f5' }}>
                        <Tabs defaultActiveKey="1" type={'card'} items={tabItems} />
                    </Content>
                </div>
            </div>
        </div>
    );
}

export default AnalysisInfo;